import OrganizationChangeLogoForm from "./OrganizationChangeLogoForm";
import LaunchdeckModal from "../../../global/components/helper-components/components/LaunchdeckModal";


export const OrganizationLogoModal = ({
  handleCloseModal,
  currentOrgLogo,
}) => {
  return (
    <LaunchdeckModal
      title={'Set organization logo'}
      handleCloseModal={() => handleCloseModal()}
      showModal={true}
      maxW='35em'
    >
      <OrganizationChangeLogoForm
        currentOrgLogo={currentOrgLogo}
        handleCloseModal={() => handleCloseModal()}
      />
    </LaunchdeckModal>
  )
}
